<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userSchedule).length===0">{{ $t('schedule.no_schedule_available' )}}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm6 md4 lg3 xl2 v-for="s in schedules" :key="s.key">
      <schedule-item :item="s" @click="onScheduleClicked"></schedule-item>
    </v-flex>
  </v-layout>

  <v-btn color="secondary" dark fixed bottom right fab @click="createSchedule" v-if="!loading && limitCount">
    <v-icon>add</v-icon>
  </v-btn>

  <schedule-editor v-if="dialogEditor" v-model="dialogEditor" :data="dialogEditorItem"></schedule-editor>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import ScheduleItem from './ScheduleItem'
import ScheduleEditorDialog from './ScheduleEditorDialog'

export default {
  name: 'Schedule',
  mixins: [UserAuth],
  components: {
    'schedule-item': ScheduleItem,
    'schedule-editor': ScheduleEditorDialog,
  },
  data() {
    return {
      dialogEditorItem: null,
      dialogEditor: false,
    }
  },
  computed: {
    loading() {
      return this.scheduleLoading;
    },
    schedules() {
      return Object.keys(this.userSchedule).map(key => {
        return {
          key: key,
          ...this.userSchedule[key]
        }
      })
    },
    limitCount() {
      return Object.keys(this.userSchedule).length < 20;
    }
  },
  methods: {
    createSchedule() {
      this.onScheduleClicked(null);
    },
    onScheduleClicked(item) {
      this.dialogEditorItem = item;
      this.dialogEditor = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/Schedule.vue